import React, { useState } from "react";
import "./QuizComponent.css";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { Button, Checkbox } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

const theme = createMuiTheme({
  body1: {
    fontFamily: "'Montserrat', sans-serif",
  },
});

const QuizComponent = (props) => {
  //  const [val]
  const [value1, setValue1] = useState(null);
  const [value2, setValue2] = useState(null);
  const [value3, setValue3] = useState(null);
  const [value4, setValue4] = useState(null);
  const [value5, setValue5] = useState(null);
  const [value6, setValue6] = useState({
    checkedA: false,
    checkedB: false,
    checkedC: false,
    checkedD: false,
    checkedE: false,
  });
  const [value7, setValue7] = useState({
    checkedA: false,
    checkedB: false,
    checkedC: false,
    checkedD: false,
    checkedE: false,
  });
  const [value8, setValue8] = useState({
    checkedA: false,
    checkedB: false,
    checkedC: false,
    checkedD: false,
  });
  const [value9, setValue9] = useState({
    checkedA: false,
    checkedB: false,
    checkedC: false,
    checkedD: false,
  });
  const [value10, setValue10] = useState({
    checkedA: false,
    checkedB: false,
    checkedC: false,
    checkedD: false,
  });
  const [value11, setValue11] = useState(null);
  const [quesNum, setquesNum] = useState(1);

  const handleChange1 = (event) => {
    setValue1(event.target.value);
  };
  const handleChange2 = (event) => {
    setValue2(event.target.value);
  };
  const handleChange3 = (event) => {
    console.log(event.target.value);
    setValue3(event.target.value);
  };
  const handleChange4 = (event) => {
    console.log(event.target.value);
    setValue4(event.target.value);
  };
  const handleChange5 = (event) => {
    setValue5(event.target.value);
  };
  const handleChange6 = (event) => {
    setValue6({ ...value6, [event.target.name]: event.target.checked });
  };
  const handleChange7 = (event) => {
    setValue7({ ...value7, [event.target.name]: event.target.checked });
  };
  const handleChange8 = (event) => {
    setValue8({ ...value8, [event.target.name]: event.target.checked });
  };
  const handleChange9 = (event) => {
    setValue9({ ...value9, [event.target.name]: event.target.checked });
  };
  const handleChange10 = (event) => {
    setValue10({ ...value10, [event.target.name]: event.target.checked });
  };
  const handleChange11 = (event) => {
    setValue11(event.target.value);
  };
  const prevClicked = () => {
    window.scrollTo(0, 0);
    setquesNum(quesNum - 1);
  };
  const nextClicked = () => {
    window.scrollTo(0, 0);
    setquesNum(quesNum + 1);
  };
  return (
    <ThemeProvider theme={theme}>
      <div className="quiz__component">
        <div className="radio_quiz">
          <div className="image__quiz"></div>
          <div clasName="Question__quiz" style={{ marginTop: "40px" }}>
            {quesNum === 1 && (
              <>
                <div className="question1">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <h2>
                        In your company, who all have individual goals assigned
                        to them?
                      </h2>
                    </FormLabel>
                    <RadioGroup value={value1} onChange={handleChange1}>
                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="Everyone!"
                      />
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Most people except support staff"
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio />}
                        label="Functional leaders, managers and team leads"
                      />
                      <FormControlLabel
                        value="3"
                        control={<Radio />}
                        label="Only leaders"
                      />
                      <FormControlLabel
                        value="4"
                        control={<Radio />}
                        label="No one"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div className="question1">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <h2>
                        In your company are the goals visible and transparent?
                      </h2>
                    </FormLabel>
                    <RadioGroup value={value2} onChange={handleChange2}>
                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="Oh Yeah - everyone can see everyone's goals"
                      />
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="It's a mix - most are visible, some are confidential"
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio />}
                        label="They're only visibly to our team members"
                      />
                      <FormControlLabel
                        value="3"
                        control={<Radio />}
                        label="Only my own and my manager's goals are visible"
                      />
                      <FormControlLabel
                        value="4"
                        control={<Radio />}
                        label="I can just see my own goals"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </>
            )}
            {quesNum === 2 && (
              <>
                <div className="question1">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <h2>
                        How often are functional and team goals reviewed by
                        leadership?
                      </h2>
                    </FormLabel>
                    <RadioGroup value={value3} onChange={handleChange3}>
                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="Half-yearly or annually"
                      />
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Quarterly"
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio />}
                        label="Monthly"
                      />
                      <FormControlLabel
                        value="3"
                        control={<Radio />}
                        label="Fortnightly"
                      />
                      <FormControlLabel
                        value="4"
                        control={<Radio />}
                        label="Weekly"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div className="question1">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <h2>What do you use to run review meetings?</h2>
                    </FormLabel>
                    <RadioGroup value={value4} onChange={handleChange4}>
                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="PPTs or Spreadsheets"
                      />
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Goal-tracking/OKR platforms"
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio />}
                        label="Different tools like ERP, CRM, HRMS, etc."
                      />
                      <FormControlLabel
                        value="3"
                        control={<Radio />}
                        label="We don't use a specific tool or platform"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </>
            )}
            {quesNum === 3 && (
              <>
                <div className="question1">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <h2>
                        How often do managers have conversations with their
                        people to review goals and discuss growth?
                      </h2>
                    </FormLabel>
                    <RadioGroup value={value5} onChange={handleChange5}>
                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="Once a year"
                      />
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Annual and mid-year check-ins"
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio />}
                        label="Quarterly check-ins"
                      />
                      <FormControlLabel
                        value="3"
                        control={<Radio />}
                        label="Monthly!"
                      />
                      <FormControlLabel
                        value="4"
                        control={<Radio />}
                        label="It's up to the manager to decide"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div className="question1">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <h2>
                        What all do managers discuss during the 1:1 check-ins?
                      </h2>
                      <p>(Select all that apply)</p>
                    </FormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value6.checkedA}
                          onChange={handleChange6}
                          name="checkedA"
                        />
                      }
                      label="Energy, emotions, engagement"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value6.checkedB}
                          onChange={handleChange6}
                          name="checkedB"
                        />
                      }
                      label="Actions, updates, obstacles"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value6.checkedC}
                          onChange={handleChange6}
                          name="checkedC"
                        />
                      }
                      label="Growth & development"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value6.checkedD}
                          onChange={handleChange6}
                          name="checkedD"
                        />
                      }
                      label="Performance feedback"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value6.checkedE}
                          onChange={handleChange6}
                          name="checkedE"
                        />
                      }
                      label="Business KPIs"
                    />
                  </FormControl>
                </div>
              </>
            )}
            {quesNum === 4 && (
              <>
                <div className="question1">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <h2>
                        When is feedback from managers, peers and team members
                        given?
                      </h2>
                      <p>(Select all that apply)</p>
                    </FormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value7.checkedA}
                          onChange={handleChange7}
                          name="checkedA"
                        />
                      }
                      label="Annually during performance appraisal/360 feedback"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value7.checkedB}
                          onChange={handleChange7}
                          name="checkedB"
                        />
                      }
                      label="End-of-projects reviews"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value7.checkedC}
                          onChange={handleChange7}
                          name="checkedC"
                        />
                      }
                      label="Monthly team meetings"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value7.checkedD}
                          onChange={handleChange7}
                          name="checkedD"
                        />
                      }
                      label="Weekly stand-ups/planning meetings"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value7.checkedE}
                          onChange={handleChange7}
                          name="checkedE"
                        />
                      }
                      label="Almost daily in the flow-of-work"
                    />
                  </FormControl>
                </div>
                <div className="question1">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <h2>
                        People are provided feedback & recognition using...
                      </h2>
                      <p>(Select all that apply)</p>
                    </FormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value8.checkedA}
                          onChange={handleChange8}
                          name="checkedA"
                        />
                      }
                      label="Annual/semi-annual 360 surveys"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value8.checkedB}
                          onChange={handleChange8}
                          name="checkedB"
                        />
                      }
                      label="Internal communication tools - email, chat, intranet, etc."
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value8.checkedC}
                          onChange={handleChange8}
                          name="checkedC"
                        />
                      }
                      label="Separate feedback/recognition tool"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value8.checkedD}
                          onChange={handleChange8}
                          name="checkedD"
                        />
                      }
                      label="Feedback/recognition window on performance platform"
                    />
                  </FormControl>
                </div>
              </>
            )}
            {quesNum === 5 && (
              <>
                <div className="question1">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <h2>
                        What all do you aim to achieve with your performance
                        review program?
                      </h2>
                      <p>(Select all that apply)</p>
                    </FormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value9.checkedA}
                          onChange={handleChange9}
                          name="checkedA"
                        />
                      }
                      label="Develop, coach and grow people"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value9.checkedB}
                          onChange={handleChange9}
                          name="checkedB"
                        />
                      }
                      label="Calculate ratings for increments & bonus"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value9.checkedC}
                          onChange={handleChange9}
                          name="checkedC"
                        />
                      }
                      label="Identify good and poor performers"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value9.checkedD}
                          onChange={handleChange9}
                          name="checkedD"
                        />
                      }
                      label="Identify and build people's strengths"
                    />
                  </FormControl>
                </div>
                <div className="question1">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <h2>
                        What all do you report to people after their reviews?
                      </h2>
                      <p>(Select all that apply)</p>
                    </FormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value10.checkedA}
                          onChange={handleChange10}
                          name="checkedA"
                        />
                      }
                      label="Performance Ratings"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value10.checkedB}
                          onChange={handleChange10}
                          name="checkedB"
                        />
                      }
                      label="Managers feedback"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value10.checkedC}
                          onChange={handleChange10}
                          name="checkedC"
                        />
                      }
                      label="Others' feedback (peers, junior colleagues and cross-functional managers)"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value10.checkedD}
                          onChange={handleChange10}
                          name="checkedD"
                        />
                      }
                      label="Growth from previous review cycles"
                    />
                  </FormControl>
                </div>
                <div className="question1">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <h2>
                        Where do you run your performance management process?
                      </h2>
                    </FormLabel>
                    <RadioGroup value={value11} onChange={handleChange11}>
                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="Spreadsheets  - Offline/online"
                      />
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="In a Performance module in our HR management system"
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio />}
                        label="Combination of Goals/OKR platform and spreadsheets"
                      />
                      <FormControlLabel
                        value="3"
                        control={<Radio />}
                        label="Separate/ dedicated performance management system"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </>
            )}

            <div className="button_change_state">
              {quesNum !== 1 && (
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "#2ecc71",
                    padding: "10px 30px",
                    textTransform: "none",
                    marginTop: "20px",
                    marginBottom: "70px",
                    borderRadius: "20px",
                    fontFamily: "Montserrat",
                  }}
                  onClick={prevClicked}
                >
                  Prev
                </Button>
              )}
              {quesNum === 1 && <div></div>}
              {quesNum === 1 && value1 !== null && value2 !== null && (
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "#2ecc71",
                    padding: "10px 30px",
                    textTransform: "none",
                    marginTop: "20px",
                    marginBottom: "70px",
                    borderRadius: "20px",
                    fontFamily: "Montserrat",
                  }}
                  onClick={nextClicked}
                >
                  Next
                </Button>
              )}
              {quesNum === 2 && value3 !== null && value4 !== null && (
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "#2ecc71",
                    padding: "10px 30px",
                    textTransform: "none",
                    marginTop: "20px",
                    marginBottom: "70px",
                    borderRadius: "20px",
                    fontFamily: "Montserrat",
                  }}
                  onClick={nextClicked}
                >
                  Next
                </Button>
              )}
              {quesNum === 3 &&
                value5 !== null &&
                (value6.checkedA !== false ||
                  value6.checkedB !== false ||
                  value6.checkedC !== false ||
                  value6.checkedD !== false ||
                  value6.checkedE !== false) && (
                  <Button
                    style={{
                      color: "white",
                      backgroundColor: "#2ecc71",
                      padding: "10px 30px",
                      textTransform: "none",
                      marginTop: "20px",
                      marginBottom: "70px",
                      borderRadius: "20px",
                      fontFamily: "Montserrat",
                    }}
                    onClick={nextClicked}
                  >
                    Next
                  </Button>
                )}
              {quesNum === 4 &&
                (value7.checkedA !== false ||
                  value7.checkedB !== false ||
                  value7.checkedC !== false ||
                  value7.checkedD !== false ||
                  value7.checkedE !== false) &&
                (value8.checkedA !== false ||
                  value8.checkedB !== false ||
                  value8.checkedC !== false ||
                  value8.checkedD !== false ||
                  value8.checkedE !== false) && (
                  <Button
                    style={{
                      color: "white",
                      backgroundColor: "#2ecc71",
                      padding: "10px 30px",
                      textTransform: "none",
                      marginTop: "20px",
                      marginBottom: "70px",
                      borderRadius: "20px",
                      fontFamily: "Montserrat",
                    }}
                    onClick={nextClicked}
                  >
                    Next
                  </Button>
                )}
              {quesNum === 5 &&
                (value9.checkedA !== false ||
                  value9.checkedB !== false ||
                  value9.checkedC !== false ||
                  value9.checkedD !== false) &&
                (value10.checkedA !== false ||
                  value10.checkedB !== false ||
                  value10.checkedC !== false ||
                  value10.checkedD !== false) &&
                value11 !== null && (
                  <Button
                    style={{
                      color: "white",
                      backgroundColor: "#2ecc71",
                      padding: "10px 30px",
                      textTransform: "none",
                      marginTop: "20px",
                      marginBottom: "70px",
                      borderRadius: "20px",
                      fontFamily: "Montserrat",
                    }}
                    onClick={() =>
                      props.quizsubmitClicked(
                        value1,
                        value2,
                        value3,
                        value4,
                        value5,
                        value6,
                        value7,
                        value8,
                        value9,
                        value10,
                        value11
                      )
                    }
                  >
                    Submit The Quiz
                  </Button>
                )}
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default QuizComponent;
